var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnackBioAppIconOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    viewBox: "0 0 35 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_2800_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7642 18.9106C20.7733 18.4295 21.805 17.9917 22.8562 17.5986L22.8562 17.5986L22.8591 17.5975C24.6582 16.9171 26.413 16.2816 28.1667 16.3204L28.167 16.3204C28.9323 16.3371 29.9884 16.6048 30.8373 17.0958C31.695 17.5918 32.1308 18.1807 32.1501 18.7735C32.1423 18.9038 32.1084 19.0329 32.0489 19.1541C31.986 19.2821 31.8951 19.3998 31.7794 19.4988L31.767 19.5095L31.755 19.5205C30.264 20.8993 28.1572 21.328 25.9078 21.0954C23.6696 20.864 21.4102 19.9852 19.7642 18.9106Z",
    stroke: "white",
    strokeWidth: 1.7,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_d_2800_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.2638 10.2254C21.4655 12.165 23.2776 14.1779 25.4516 15.4867C25.0074 15.6626 24.5659 15.8398 24.1273 16.0158C24.0651 16.0407 24.003 16.0657 23.941 16.0906C22.7356 16.5741 21.5503 17.0471 20.3561 17.4743C17.9694 18.3281 15.5888 18.983 13.072 19.1449C7.45016 19.4984 2.48195 16.196 1.94768 10.7291L1.93329 10.5818L1.91983 10.5492C1.65404 7.1294 3.52405 4.1635 6.21474 2.6375C8.9223 1.10193 12.4003 1.05698 15.3011 3.50404L15.3014 3.50434C17.0891 5.01105 18.3059 7.01223 19.5988 9.13854C19.8172 9.49784 20.0379 9.86071 20.2638 10.2254Z",
    stroke: "white",
    strokeWidth: 2,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_d_2800_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.95832 6.6362L7.74281 7.31361C7.77582 7.33968 7.80251 7.37283 7.82085 7.41061C7.83918 7.44839 7.84871 7.48985 7.84871 7.53181C7.84871 7.57377 7.83918 7.61517 7.82085 7.65296C7.80251 7.69074 7.77582 7.72393 7.74281 7.75C7.52971 7.91799 7.26946 8.01579 6.99806 8.02994C6.72665 8.04409 6.45758 7.97385 6.22804 7.82894C6.07076 7.73125 5.9343 7.60368 5.82653 7.45348C5.71876 7.30328 5.64179 7.13341 5.59994 6.95357C5.55809 6.77374 5.55219 6.58747 5.58262 6.40537C5.61306 6.22327 5.67922 6.04891 5.77732 5.89227C5.87541 5.73564 6.00351 5.59979 6.15433 5.49246C6.30514 5.38513 6.47572 5.30843 6.6563 5.26676C6.83687 5.22508 7.02391 5.21924 7.20676 5.24956C7.38961 5.27987 7.56469 5.34576 7.72197 5.44345C7.92057 5.56392 8.08426 5.73378 8.19694 5.93636C8.30962 6.13893 8.36742 6.36725 8.36464 6.59881C8.36555 6.64137 8.35677 6.68357 8.33901 6.72229C8.32125 6.76101 8.29494 6.79521 8.26204 6.82238C8.22914 6.84955 8.1905 6.86898 8.14901 6.8792C8.10751 6.88942 8.06424 6.89016 8.02242 6.88138L6.95832 6.6362Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_4",
    filter: "url(#filter3_d_2800_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3594 10.3884L16.1451 11.066C16.1751 11.0917 16.1992 11.1236 16.2157 11.1595C16.2323 11.1953 16.2408 11.2343 16.2408 11.2738C16.2408 11.3132 16.2323 11.3522 16.2157 11.3881C16.1992 11.4239 16.1751 11.4559 16.1451 11.4816C15.9333 11.6511 15.6735 11.7502 15.4021 11.7651C15.1308 11.78 14.8615 11.7099 14.6323 11.5647C14.4748 11.467 14.3381 11.3394 14.2302 11.1892C14.1223 11.039 14.0452 10.8691 14.0033 10.6892C13.9614 10.5094 13.9555 10.323 13.986 10.1409C14.0165 9.95879 14.0827 9.7844 14.1809 9.62774C14.2792 9.47108 14.4075 9.3352 14.5585 9.22786C14.7095 9.12051 14.8803 9.0438 15.0612 9.00211C15.242 8.96043 15.4293 8.95459 15.6124 8.98491C15.7955 9.01523 15.9709 9.08113 16.1284 9.17884C16.3276 9.29859 16.4916 9.46846 16.6039 9.67132C16.7161 9.87419 16.7727 10.1029 16.7678 10.3344C16.7695 10.3772 16.7613 10.4198 16.7437 10.459C16.7262 10.4981 16.6999 10.5327 16.6667 10.56C16.6335 10.5874 16.5945 10.6067 16.5526 10.6166C16.5107 10.6265 16.467 10.6266 16.4251 10.617L15.3594 10.3884Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    filter: "url(#filter4_d_2800_1093)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2603 12.7007C11.138 12.7001 11.0169 12.6709 10.9035 12.6146C10.721 12.4983 10.559 12.3387 10.4266 12.1448C10.2943 11.951 10.1942 11.7268 10.1323 11.4851C9.94156 11.6044 9.73078 11.6665 9.517 11.6665C9.30321 11.6665 9.09243 11.6044 8.90171 11.4851C8.74328 11.352 8.61219 11.1751 8.5189 10.9685C8.42561 10.7618 8.37272 10.5311 8.36438 10.2948C8.36213 10.1943 8.39177 10.0968 8.44695 10.023C8.50213 9.9492 8.57846 9.90498 8.6597 9.89973C8.70011 9.89769 8.74047 9.9055 8.77843 9.92273C8.81638 9.93996 8.85121 9.96627 8.88092 10.0001C8.91064 10.034 8.93463 10.0748 8.95158 10.1202C8.96852 10.1655 8.97808 10.2145 8.97967 10.2644C8.98439 10.3744 9.00804 10.4819 9.04907 10.5797C9.09009 10.6776 9.14753 10.7634 9.21756 10.8317C9.40215 10.9684 9.74263 10.8925 10.1651 10.6291C10.2071 10.6028 10.2534 10.5891 10.3005 10.5891C10.3475 10.5891 10.3939 10.6028 10.4358 10.6291C10.4789 10.6539 10.5168 10.6904 10.5467 10.7361C10.5765 10.7817 10.5976 10.8353 10.6081 10.8925C10.645 11.1103 10.8255 11.7687 11.1209 11.9055C11.1701 11.9055 11.3177 12.0068 11.6213 11.7636C11.6893 11.7079 11.7724 11.6878 11.8524 11.7077C11.9324 11.7277 12.0028 11.786 12.0479 11.87C12.0931 11.9539 12.1093 12.0567 12.0932 12.1555C12.077 12.2542 12.0298 12.341 11.9618 12.3968C11.7562 12.5787 11.5128 12.6841 11.2603 12.7007Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2800_1093",
    x: 18.0605,
    y: 15.4688,
    width: 16.9404,
    height: 9.53613,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2800_1093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2800_1093",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2800_1093",
    x: 0.894531,
    y: 0.561523,
    width: 29.0791,
    height: 22.6084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2800_1093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2800_1093",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_2800_1093",
    x: 5.56348,
    y: 5.23047,
    width: 4.80078,
    height: 5.80078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2800_1093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2800_1093",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_2800_1093",
    x: 13.9668,
    y: 8.96582,
    width: 4.80078,
    height: 5.80078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2800_1093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2800_1093",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_2800_1093",
    x: 8.36426,
    y: 9.89941,
    width: 5.73535,
    height: 5.80078,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2800_1093"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2800_1093",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnackBioAppIconOutlined);
export default __webpack_public_path__ + "static/media/snack-bio-app-icon-outlined.add52aad.svg";
export { ForwardRef as ReactComponent };